import { Navigate, Outlet } from "react-router-dom";
import { usePatientAuthStore } from "@/stores/patientAuthStore";

export function PatientGuestOnly() {
  const isAuthenticated = usePatientAuthStore((s) => s.isAuthenticated);
  const isLoading = usePatientAuthStore((s) => s.isLoading);

  if (isLoading) return null; // wait for session restore before deciding
  if (isAuthenticated) return <Navigate to="/patient" replace />;
  return <Outlet />;
}
